const SiteTemplateSVG = (props) => (
    <svg
        width={1079}
        height={579}
        viewBox="0 0 1079 579"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect width={1079} height={579} fill="#1E1E1E" />
        <g id="Export">
            <rect width={1680} height={1180} transform="translate(-301 -301)" fill="#444444" />
            <g id="Combined" clipPath="url(#clip0_1511_8141)">
                <rect width={1480} height={980} transform="translate(-201 -201)" fill="white" />
                <g id="Gradient" filter="url(#filter0_f_1511_8141)">
                    <g id="Ellipse 4" filter="url(#filter1_f_1511_8141)">
                        <path
                            d="M941.979 -1311.85C851.126 -1497.5 -670.128 -2377.99 -796.355 -2380.29C-1044.05 -2384.8 -1134.52 -308.814 -1209.16 -531.346C-1283.8 -753.878 -504.014 1010.26 116.1 -230.213C271.898 -541.871 951.012 205.65 946.586 -31.8721C944.283 -155.462 399.675 -614.367 288.312 -689.528C83.5603 -923.556 1063.19 -1167.49 941.979 -1311.85Z"
                            fill="url(#paint0_linear_1511_8141)"
                            fillOpacity={0.7}
                        />
                    </g>
                    <g id="Ellipse 5" filter="url(#filter2_f_1511_8141)">
                        <path
                            d="M575.84 197.132C553.149 -27.6931 918.945 -503.308 790.174 -553.786C537.484 -652.841 -372.877 383.922 -777.209 1004.16C-1387.59 1940.47 -442.051 779.651 326.661 1342.59C859.953 1733.12 727.721 1206.34 813.53 961.319C858.179 833.828 1196.3 633.497 1110.52 514.042C989.246 196.231 645.421 391.232 575.84 197.132Z"
                            fill="url(#paint1_linear_1511_8141)"
                        />
                    </g>
                    <g id="Ellipse 10" filter="url(#filter3_f_1511_8141)">
                        <path
                            d="M173.824 377.141C151.133 152.315 516.929 -323.3 388.158 -373.778C135.467 -472.832 -774.893 563.93 -1179.22 1184.17C-1789.6 2120.48 -844.068 959.66 -75.3557 1522.6C457.936 1913.13 325.705 1386.35 411.514 1141.33C456.163 1013.84 794.288 813.505 708.501 694.05C587.23 376.239 243.404 571.24 173.824 377.141Z"
                            fill="url(#paint2_linear_1511_8141)"
                        />
                    </g>
                </g>
                <rect
                    id="Inner gradient"
                    x={-20}
                    y={-20}
                    width={1000}
                    height={619}
                    fill="url(#paint3_linear_1511_8141)"
                />
                <g id="Grid" opacity={0.15}>
                    <rect
                        id="Outer line"
                        x={-40.5}
                        y={-40.5}
                        width={1160}
                        height={660}
                        rx={12}
                        stroke="black"
                    />
                </g>
                <g id="preview">
                    <g clipPath="url(#clip1_1511_8141)">
                        <rect width={1079} height={579} rx={8} fill="white" />
                        <g id="advert">
                            <text
                                id="text"
                                fill="#949494"
                                xmlSpace="preserve"
                                style={{
                                    whiteSpace: 'pre',
                                }}
                                className="font-sans"
                                fontSize={11}
                                letterSpacing="0em"
                            >
                                <tspan x={948.159} y={568.5}>
                                    {'Sponsored via GitBook'}
                                </tspan>
                            </text>
                            <g id="card">
                                <rect
                                    x={901}
                                    y={386}
                                    width={166}
                                    height={164}
                                    rx={8}
                                    fill="#F7F7F8"
                                />
                                <rect
                                    id="text2"
                                    x={917}
                                    y={526}
                                    width={126}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="text1"
                                    x={917}
                                    y={510}
                                    width={134}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <g id="image">
                                    <rect
                                        x={909}
                                        y={394}
                                        width={150}
                                        height={100}
                                        rx={4}
                                        fill="#32324B"
                                    />
                                    <path
                                        id="band5"
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M984 457C974.611 457 967 464.611 967 474C967 475.657 965.657 477 964 477C962.343 477 961 475.657 961 474C961 461.297 971.297 451 984 451C996.703 451 1007 461.297 1007 474C1007 475.657 1005.66 477 1004 477C1002.34 477 1001 475.657 1001 474C1001 464.611 993.389 457 984 457Z"
                                        fill="url(#paint4_radial_1511_8141)"
                                    />
                                    <path
                                        id="band4"
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M984 447C969.088 447 957 459.088 957 474C957 475.657 955.657 477 954 477C952.343 477 951 475.657 951 474C951 455.775 965.775 441 984 441C1002.23 441 1017 455.775 1017 474C1017 475.657 1015.66 477 1014 477C1012.34 477 1011 475.657 1011 474C1011 459.088 998.912 447 984 447Z"
                                        fill="url(#paint5_radial_1511_8141)"
                                    />
                                    <path
                                        id="band3"
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M984 437C963.565 437 947 453.565 947 474C947 475.657 945.657 477 944 477C942.343 477 941 475.657 941 474C941 450.252 960.252 431 984 431C1007.75 431 1027 450.252 1027 474C1027 475.657 1025.66 477 1024 477C1022.34 477 1021 475.657 1021 474C1021 453.565 1004.43 437 984 437Z"
                                        fill="url(#paint6_radial_1511_8141)"
                                    />
                                    <path
                                        id="band2"
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M984 427C958.043 427 937 448.043 937 474C937 475.657 935.657 477 934 477C932.343 477 931 475.657 931 474C931 444.729 954.729 421 984 421C1013.27 421 1037 444.729 1037 474C1037 475.657 1035.66 477 1034 477C1032.34 477 1031 475.657 1031 474C1031 448.043 1009.96 427 984 427Z"
                                        fill="url(#paint7_radial_1511_8141)"
                                    />
                                    <path
                                        id="band1"
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M984 417C952.52 417 927 442.52 927 474C927 475.657 925.657 477 924 477C922.343 477 921 475.657 921 474C921 439.206 949.206 411 984 411C1018.79 411 1047 439.206 1047 474C1047 475.657 1045.66 477 1044 477C1042.34 477 1041 475.657 1041 474C1041 442.52 1015.48 417 984 417Z"
                                        fill="url(#paint8_radial_1511_8141)"
                                    />
                                </g>
                            </g>
                        </g>
                        <g id="tableOfContents">
                            <g id="pageRating">
                                <rect
                                    x={901.5}
                                    y={246.5}
                                    width={67}
                                    height={27}
                                    rx={13.5}
                                    fill="white"
                                />
                                <rect
                                    x={901.5}
                                    y={246.5}
                                    width={67}
                                    height={27}
                                    rx={13.5}
                                    stroke="#E6E7EA"
                                />
                                <g id="helpful" clipPath="url(#clip2_1511_8141)">
                                    <circle
                                        id="head"
                                        cx={955}
                                        cy={260}
                                        r={7.25}
                                        stroke="#C3C5CB"
                                        strokeWidth={1.5}
                                    />
                                    <path
                                        id="mouth"
                                        d="M951.75 260.75C951.75 260.75 952 263.25 955 263.25C958 263.25 958.25 260.75 958.25 260.75"
                                        stroke="#C3C5CB"
                                        strokeWidth={1.5}
                                        strokeLinecap="round"
                                    />
                                    <circle id="eye2" cx={957} cy={258} r={1} fill="#C3C5CB" />
                                    <circle id="eye1" cx={953} cy={258} r={1} fill="#C3C5CB" />
                                </g>
                                <g id="neutral" clipPath="url(#clip3_1511_8141)">
                                    <circle
                                        id="head_2"
                                        cx={935}
                                        cy={260}
                                        r={7.25}
                                        stroke="#C3C5CB"
                                        strokeWidth={1.5}
                                    />
                                    <path
                                        id="mouth_2"
                                        d="M932.75 262.25C934.132 262.25 937.25 262.25 937.25 262.25"
                                        stroke="#C3C5CB"
                                        strokeWidth={1.5}
                                        strokeLinecap="round"
                                    />
                                    <circle id="eye2_2" cx={937} cy={258} r={1} fill="#C3C5CB" />
                                    <circle id="eye1_2" cx={933} cy={258} r={1} fill="#C3C5CB" />
                                </g>
                                <g id="notHelpful" clipPath="url(#clip4_1511_8141)">
                                    <circle
                                        id="head_3"
                                        cx={915}
                                        cy={260}
                                        r={7.25}
                                        stroke="#C3C5CB"
                                        strokeWidth={1.5}
                                    />
                                    <path
                                        id="mouth_3"
                                        d="M911.75 263.25C911.75 263.25 912 260.75 915 260.75C918 260.75 918.25 263.25 918.25 263.25"
                                        stroke="#C3C5CB"
                                        strokeWidth={1.5}
                                        strokeLinecap="round"
                                    />
                                    <circle id="eye2_3" cx={917} cy={258} r={1} fill="#C3C5CB" />
                                    <circle id="eye1_3" cx={913} cy={258} r={1} fill="#C3C5CB" />
                                </g>
                            </g>
                            <g id="pageNavigation">
                                <g id="links">
                                    <rect
                                        id="link4"
                                        x={919}
                                        y={214}
                                        width={96}
                                        height={8}
                                        rx={4}
                                        fill="#E6E7EA"
                                    />
                                    <rect
                                        id="link3"
                                        x={919}
                                        y={194}
                                        width={74}
                                        height={8}
                                        rx={4}
                                        fill="#E6E7EA"
                                    />
                                    <rect
                                        id="link2"
                                        x={919}
                                        y={174}
                                        width={80}
                                        height={8}
                                        rx={4}
                                        fill="#E6E7EA"
                                    />
                                    <rect
                                        id="link1"
                                        x={919}
                                        y={154}
                                        width={57}
                                        height={8}
                                        rx={4}
                                        fill="#84D0EF"
                                    />
                                </g>
                                <rect
                                    id="border"
                                    x={901}
                                    y={154}
                                    width={2}
                                    height={68}
                                    fill="#E6E7EA"
                                />
                            </g>
                        </g>
                        <g id="contentPublish">
                            <g id="table">
                                <g id="row2">
                                    <rect
                                        id="text2_2"
                                        x={510}
                                        y={562}
                                        width={164}
                                        height={8}
                                        rx={4}
                                        fill="#E6E7EA"
                                    />
                                    <rect
                                        id="text1_2"
                                        x={510}
                                        y={542}
                                        width={264}
                                        height={8}
                                        rx={4}
                                        fill="#E6E7EA"
                                    />
                                    <rect
                                        id="checkbox"
                                        x={447}
                                        y={540}
                                        width={12}
                                        height={12}
                                        rx={3}
                                        fill="#E7C4C4"
                                    />
                                    <rect
                                        id="key"
                                        x={284}
                                        y={542}
                                        width={96}
                                        height={8}
                                        rx={4}
                                        fill="#E6E7EA"
                                    />
                                </g>
                                <g id="row1">
                                    <rect
                                        id="border_2"
                                        x={284}
                                        y={529}
                                        width={512}
                                        height={1}
                                        fill="#E6E7EA"
                                    />
                                    <rect
                                        id="text2_3"
                                        x={510}
                                        y={509}
                                        width={216}
                                        height={8}
                                        rx={4}
                                        fill="#E6E7EA"
                                    />
                                    <rect
                                        id="text1_3"
                                        x={510}
                                        y={489}
                                        width={254}
                                        height={8}
                                        rx={4}
                                        fill="#E6E7EA"
                                    />
                                    <rect
                                        id="checkbox_2"
                                        x={447}
                                        y={487}
                                        width={12}
                                        height={12}
                                        rx={3}
                                        fill="#C7E6D0"
                                    />
                                    <rect
                                        id="key_2"
                                        x={284}
                                        y={489}
                                        width={80}
                                        height={8}
                                        rx={4}
                                        fill="#E6E7EA"
                                    />
                                </g>
                                <g id="header">
                                    <rect
                                        id="border_3"
                                        x={284}
                                        y={476}
                                        width={512}
                                        height={1}
                                        fill="#E6E7EA"
                                    />
                                    <rect
                                        id="heading3"
                                        x={510}
                                        y={456}
                                        width={36}
                                        height={8}
                                        rx={4}
                                        fill="#C3C5CB"
                                    />
                                    <rect
                                        id="heading2"
                                        x={429}
                                        y={456}
                                        width={48}
                                        height={8}
                                        rx={4}
                                        fill="#C3C5CB"
                                    />
                                    <rect
                                        id="heading1"
                                        x={284}
                                        y={456}
                                        width={52}
                                        height={8}
                                        rx={4}
                                        fill="#C3C5CB"
                                    />
                                </g>
                                <g id="structure">
                                    <rect
                                        id="border2"
                                        x={493}
                                        y={450}
                                        width={1}
                                        height={232}
                                        fill="#E6E7EA"
                                    />
                                    <rect
                                        id="border1"
                                        x={412}
                                        y={450}
                                        width={1}
                                        height={232}
                                        fill="#E6E7EA"
                                    />
                                </g>
                            </g>
                            <g id="video">
                                <rect
                                    x={284}
                                    y={214}
                                    width={512}
                                    height={204}
                                    rx={6}
                                    fill="#D7EEE7"
                                />
                                <g id="play" clipPath="url(#clip5_1511_8141)">
                                    <path
                                        id="background"
                                        d="M564.865 303.637C564.264 301.429 562.496 299.681 560.259 299.088C556.221 298 539.967 298 539.967 298C539.967 298 523.712 298.033 519.674 299.121C517.438 299.714 515.669 301.462 515.068 303.67C514 307.659 514 316 514 316C514 316 514 324.341 515.101 328.363C515.702 330.571 517.471 332.319 519.707 332.912C523.746 334 540 334 540 334C540 334 556.254 334 560.293 332.912C562.529 332.319 564.298 330.571 564.899 328.363C566 324.374 566 316 566 316C566 316 565.967 307.659 564.865 303.637Z"
                                        fill="#D57676"
                                    />
                                    <path
                                        id="icon"
                                        d="M534 324L548 316L534 308V324Z"
                                        fill="white"
                                    />
                                </g>
                            </g>
                            <rect
                                id="heading"
                                x={284}
                                y={174}
                                width={120}
                                height={8}
                                rx={4}
                                fill="#C3C5CB"
                            />
                            <rect
                                id="context"
                                x={284}
                                y={154}
                                width={64}
                                height={8}
                                rx={4}
                                fill="#84D0EF"
                            />
                        </g>
                        <g id="contentFeatures">
                            <g id="code">
                                <rect
                                    x={284}
                                    y={509}
                                    width={512}
                                    height={188}
                                    rx={6}
                                    fill="#F7F7F8"
                                />
                                <g id="row1_2">
                                    <rect
                                        id="Key"
                                        x={312}
                                        y={569}
                                        width={72}
                                        height={8}
                                        rx={4}
                                        fill="#D0C7E1"
                                    />
                                    <rect
                                        id="Value"
                                        x={392}
                                        y={569}
                                        width={54}
                                        height={8}
                                        rx={4}
                                        fill="#B6D2C9"
                                    />
                                </g>
                                <rect
                                    id="curlyBrace1"
                                    x={300}
                                    y={545}
                                    width={4}
                                    height={12}
                                    rx={2}
                                    fill="#C3C5CB"
                                />
                                <rect
                                    id="comment"
                                    x={300}
                                    y={525}
                                    width={56}
                                    height={8}
                                    rx={4}
                                    fill="#A0C3CE"
                                />
                            </g>
                            <g id="paragraph2">
                                <rect
                                    id="text3"
                                    x={284}
                                    y={469}
                                    width={290}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="text2_4"
                                    x={284}
                                    y={449}
                                    width={490}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="text1_4"
                                    x={284}
                                    y={429}
                                    width={496}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                            </g>
                            <g id="tabs">
                                <rect
                                    x={284.5}
                                    y={274.5}
                                    width={511}
                                    height={122}
                                    rx={5.5}
                                    stroke="#E6E7EA"
                                />
                                <g id="body">
                                    <rect
                                        id="text_2"
                                        x={300}
                                        y={373}
                                        width={440}
                                        height={8}
                                        rx={4}
                                        fill="#E6E7EA"
                                    />
                                    <g id="code_2">
                                        <rect
                                            x={300}
                                            y={317}
                                            width={480}
                                            height={40}
                                            rx={6}
                                            fill="#F7F7F8"
                                        />
                                        <g id="row">
                                            <rect
                                                id="key_3"
                                                x={316}
                                                y={333}
                                                width={30}
                                                height={8}
                                                rx={4}
                                                fill="#D0C7E1"
                                            />
                                            <rect
                                                id="value"
                                                x={354}
                                                y={333}
                                                width={322}
                                                height={8}
                                                rx={4}
                                                fill="#B6D2C9"
                                            />
                                        </g>
                                    </g>
                                </g>
                                <g id="heading_2">
                                    <rect
                                        id="background_2"
                                        x={370}
                                        y={275}
                                        width={425}
                                        height={26}
                                        fill="#F7F7F8"
                                    />
                                    <rect
                                        id="tab2"
                                        x={386}
                                        y={285}
                                        width={54}
                                        height={6}
                                        rx={3}
                                        fill="#E6E7EA"
                                    />
                                    <rect
                                        id="tab1"
                                        x={300}
                                        y={285}
                                        width={54}
                                        height={6}
                                        rx={3}
                                        fill="#C3C5CB"
                                    />
                                </g>
                            </g>
                            <g id="paragraph1">
                                <rect
                                    id="text2_5"
                                    x={284}
                                    y={234}
                                    width={426}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="text1_5"
                                    x={284}
                                    y={214}
                                    width={496}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                            </g>
                            <rect
                                id="heading_3"
                                x={284}
                                y={174}
                                width={120}
                                height={8}
                                rx={4}
                                fill="#C3C5CB"
                            />
                            <rect
                                id="context_2"
                                x={284}
                                y={154}
                                width={64}
                                height={8}
                                rx={4}
                                fill="#84D0EF"
                            />
                        </g>
                        <g id="contentContent">
                            <g id="cards">
                                <g id="card3">
                                    <g clipPath="url(#clip6_1511_8141)">
                                        <rect
                                            x={636}
                                            y={525}
                                            width={160}
                                            height={91}
                                            rx={6}
                                            fill="#F7E3B0"
                                        />
                                        <g id="shape4" filter="url(#filter4_f_1511_8141)">
                                            <path
                                                d="M640.015 673.719C558.073 562.324 547.984 478.881 636.706 386.795C725.427 294.709 926.106 317.868 1014.54 403.074C1067.18 453.792 794.479 581.489 754.911 672.552C738.043 711.37 917.006 612.721 905.882 653.978C878.549 724.172 860.073 760.892 817.163 775C769.515 790.666 684.164 733.736 640.015 673.719Z"
                                                fill="url(#paint9_linear_1511_8141)"
                                            />
                                        </g>
                                        <g
                                            id="shape3"
                                            opacity={0.4}
                                            filter="url(#filter5_f_1511_8141)"
                                        >
                                            <path
                                                d="M737.7 549.023C668.712 482.556 621.413 412.083 701.17 329.302C780.926 246.521 901.507 233.296 970.495 299.763C1011.56 339.327 916.483 345.172 877.943 424.173C861.514 457.848 942.964 504.703 910.682 538.209C872.89 577.434 865.975 630.922 829.209 645.346C788.382 661.362 773.998 583.995 737.7 549.023Z"
                                                fill="#FDA599"
                                            />
                                        </g>
                                        <g id="shape2" filter="url(#filter6_f_1511_8141)">
                                            <path
                                                d="M552.275 628.215C475.519 554.263 513.064 361.142 593.49 277.666C673.916 194.189 762.865 272.022 839.621 345.974C885.309 389.993 869.999 384.159 877.601 407.687C889.991 446.033 866.531 474.863 833.978 508.65C795.869 548.205 814.503 565.668 776.191 579.023C733.65 593.852 592.661 667.125 552.275 628.215Z"
                                                fill="#D0E2DB"
                                            />
                                        </g>
                                        <g id="shape1" filter="url(#filter7_f_1511_8141)">
                                            <path
                                                d="M567.612 523.342C530.936 488.006 566.535 470.009 607.205 427.796C647.876 385.584 689.375 365.93 726.051 401.266C737.541 412.336 767.631 437.536 772.743 453.594C783.949 488.796 756.989 520.604 729.06 549.592C706.716 572.784 665.003 593.777 637.329 594.143C614.631 594.443 584.139 539.264 567.612 523.342Z"
                                                fill="#FEE4E1"
                                            />
                                        </g>
                                    </g>
                                </g>
                                <g id="card2">
                                    <g clipPath="url(#clip7_1511_8141)">
                                        <rect
                                            x={460}
                                            y={525}
                                            width={160}
                                            height={91}
                                            rx={6}
                                            fill="#F1F6F6"
                                        />
                                        <g id="shape4_2" filter="url(#filter8_f_1511_8141)">
                                            <path
                                                d="M464.015 673.719C382.073 562.324 371.984 478.881 460.706 386.795C549.427 294.709 750.106 317.868 838.543 403.074C891.185 453.792 618.479 581.489 578.911 672.552C562.043 711.37 741.006 612.721 729.882 653.978C702.549 724.172 684.073 760.892 641.163 775C593.515 790.666 508.164 733.736 464.015 673.719Z"
                                                fill="url(#paint10_linear_1511_8141)"
                                            />
                                        </g>
                                        <g
                                            id="shape3_2"
                                            opacity={0.8}
                                            filter="url(#filter9_f_1511_8141)"
                                        >
                                            <path
                                                d="M561.7 549.023C492.712 482.556 445.413 412.083 525.17 329.302C604.926 246.521 725.507 233.296 794.495 299.763C835.559 339.327 740.483 345.172 701.943 424.173C685.514 457.848 766.964 504.703 734.682 538.209C696.89 577.434 689.975 630.922 653.209 645.346C612.382 661.362 597.998 583.995 561.7 549.023Z"
                                                fill="#FDA599"
                                            />
                                        </g>
                                        <g id="shape2_2" filter="url(#filter10_f_1511_8141)">
                                            <path
                                                d="M396.275 658.215C319.519 584.263 357.064 391.142 437.49 307.666C517.916 224.189 606.865 302.022 683.621 375.974C729.309 419.993 713.999 414.159 721.601 437.687C733.991 476.033 710.531 504.863 677.978 538.65C639.869 578.205 658.503 595.668 620.191 609.023C577.65 623.852 436.661 697.125 396.275 658.215Z"
                                                fill="url(#paint11_linear_1511_8141)"
                                            />
                                        </g>
                                        <g id="shape1_2" filter="url(#filter11_f_1511_8141)">
                                            <path
                                                d="M484.892 515.275C443.728 475.615 483.683 455.416 529.33 408.038C574.977 360.66 621.555 338.601 662.719 378.262C675.615 390.686 709.387 418.969 715.125 436.993C727.702 476.502 697.444 512.202 666.096 544.738C641.018 570.768 594.201 594.33 563.14 594.741C537.664 595.078 503.441 533.147 484.892 515.275Z"
                                                fill="#F8E3AF"
                                                fillOpacity={0.9}
                                            />
                                        </g>
                                    </g>
                                </g>
                                <g id="card1">
                                    <g clipPath="url(#clip8_1511_8141)">
                                        <rect
                                            x={284}
                                            y={525}
                                            width={160}
                                            height={91}
                                            rx={6}
                                            fill="#F7E3B0"
                                        />
                                        <g id="shape4_3" filter="url(#filter12_f_1511_8141)">
                                            <path
                                                d="M288.015 673.719C206.073 562.324 195.984 478.881 284.706 386.795C373.427 294.709 574.106 317.868 662.543 403.074C715.185 453.792 442.479 581.489 402.911 672.552C386.043 711.37 565.006 612.721 553.882 653.978C526.549 724.172 508.073 760.892 465.163 775C417.515 790.666 332.164 733.736 288.015 673.719Z"
                                                fill="#D3E1D6"
                                            />
                                        </g>
                                        <g
                                            id="shape3_3"
                                            opacity={0.4}
                                            filter="url(#filter13_f_1511_8141)"
                                        >
                                            <path
                                                d="M385.7 549.023C316.712 482.556 269.413 412.083 349.17 329.302C428.926 246.521 549.507 233.296 618.495 299.763C659.559 339.327 564.483 345.172 525.943 424.173C509.514 457.848 590.964 504.703 558.682 538.209C520.89 577.434 513.975 630.922 477.209 645.346C436.382 661.362 421.998 583.995 385.7 549.023Z"
                                                fill="#D1E8ED"
                                            />
                                        </g>
                                        <g id="shape2_3" filter="url(#filter14_f_1511_8141)">
                                            <path
                                                d="M399.404 729.998C367.189 801.173 224.596 822.689 147.19 787.654C69.7827 752.619 101.682 672.07 133.897 600.894C153.072 558.528 152.805 570.535 167.185 559.505C190.623 541.528 216.296 550.646 247.627 564.827C284.306 581.428 291.788 564.269 310.423 587.446C331.115 613.182 416.354 692.548 399.404 729.998Z"
                                                fill="#F6E3B1"
                                            />
                                        </g>
                                        <g id="shape1_3" filter="url(#filter15_f_1511_8141)">
                                            <path
                                                d="M567.404 724.998C535.189 796.173 392.596 817.689 315.19 782.654C237.783 747.619 269.682 667.07 301.897 595.894C321.072 553.528 320.805 565.535 335.185 554.505C358.623 536.528 384.296 545.646 415.627 559.827C452.306 576.428 459.788 559.269 478.423 582.446C499.115 608.182 584.354 687.548 567.404 724.998Z"
                                                fill="#FDE4D9"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g id="paragraph3">
                                <rect
                                    id="text2_6"
                                    x={284}
                                    y={485}
                                    width={160}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="text1_6"
                                    x={284}
                                    y={465}
                                    width={506}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                            </g>
                            <g id="paragraph2_2">
                                <rect
                                    id="text2_7"
                                    x={284}
                                    y={425}
                                    width={390}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="text1_7"
                                    x={284}
                                    y={405}
                                    width={506}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                            </g>
                            <g id="paragraph1_2">
                                <rect
                                    id="text2_8"
                                    x={284}
                                    y={365}
                                    width={290}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="text1_8"
                                    x={284}
                                    y={345}
                                    width={506}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                            </g>
                            <rect
                                id="heading_4"
                                x={284}
                                y={305}
                                width={160}
                                height={8}
                                rx={4}
                                fill="#C3C5CB"
                            />
                            <rect
                                id="context_3"
                                x={284}
                                y={285}
                                width={64}
                                height={8}
                                rx={4}
                                fill="#84D0EF"
                            />
                            <g id="hero" clipPath="url(#clip9_1511_8141)">
                                <rect
                                    width={814}
                                    height={164}
                                    transform="translate(217 89)"
                                    fill="white"
                                />
                                <g id="shape4_4" opacity={0.3} filter="url(#filter16_f_1511_8141)">
                                    <path
                                        d="M608.479 643.961C439.411 481.07 323.495 308.362 518.955 105.49C714.414 -97.3818 1009.92 -129.792 1178.99 33.099C1279.63 130.059 1046.62 144.382 952.174 337.989C911.912 420.519 1111.52 535.345 1032.41 617.459C939.79 713.587 922.845 844.671 832.741 880.02C732.688 919.272 697.436 729.668 608.479 643.961Z"
                                        fill="#FDA599"
                                    />
                                </g>
                                <g id="shape3_4" opacity={0.6} filter="url(#filter17_f_1511_8141)">
                                    <path
                                        d="M252.495 949.553C51.6784 676.558 26.9546 472.063 244.385 246.388C461.815 20.7125 953.621 77.4675 1170.35 286.282C1299.36 410.578 631.042 723.526 534.07 946.695C492.734 1041.83 931.319 800.065 904.056 901.175C837.072 1073.2 791.793 1163.19 686.633 1197.76C569.862 1236.16 360.691 1096.64 252.495 949.553Z"
                                        fill="url(#paint12_linear_1511_8141)"
                                    />
                                </g>
                                <g id="shape2_4" opacity={0.8} filter="url(#filter18_f_1511_8141)">
                                    <path
                                        d="M86.4839 911.556C-101.623 730.322 -9.61133 257.039 187.49 52.4636C384.591 -152.112 602.578 38.6334 790.685 219.868C902.654 327.746 865.131 313.449 883.762 371.107C914.127 465.082 856.634 535.736 776.855 618.539C683.461 715.475 729.128 758.274 635.238 791.002C530.981 827.343 185.458 1006.91 86.4839 911.556Z"
                                        fill="url(#paint13_linear_1511_8141)"
                                        fillOpacity={0.9}
                                    />
                                </g>
                                <g id="shape1_4" opacity={0.9} filter="url(#filter19_f_1511_8141)">
                                    <path
                                        d="M269.27 671.137C117.362 524.779 243.716 472.128 379.341 331.361C514.965 190.594 662.8 134.155 814.708 280.513C862.296 326.363 985.399 432.325 1011.06 494.176C1067.32 629.763 978.959 737.32 885.822 833.989C811.311 911.325 663.217 972.668 559.494 962.869C474.42 954.831 337.721 737.087 269.27 671.137Z"
                                        fill="#D6E5D9"
                                    />
                                </g>
                            </g>
                        </g>
                        <g id="contentName">
                            <g id="alert">
                                <rect
                                    x={284}
                                    y={526}
                                    width={512}
                                    height={60}
                                    rx={6}
                                    fill="#EFF6FB"
                                />
                                <rect
                                    id="text2_9"
                                    x={300}
                                    y={562}
                                    width={270}
                                    height={8}
                                    rx={4}
                                    fill="#D0E3F0"
                                />
                                <rect
                                    id="text1_9"
                                    x={300}
                                    y={542}
                                    width={466}
                                    height={8}
                                    rx={4}
                                    fill="#D0E3F0"
                                />
                            </g>
                            <g id="paragraph2_3">
                                <rect
                                    id="text2_10"
                                    x={284}
                                    y={486}
                                    width={390}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="text1_10"
                                    x={284}
                                    y={466}
                                    width={506}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                            </g>
                            <g id="image_2">
                                <g clipPath="url(#clip10_1511_8141)">
                                    <rect
                                        x={284}
                                        y={294}
                                        width={512}
                                        height={140}
                                        rx={6}
                                        fill="white"
                                    />
                                    <g id="gradient">
                                        <g id="shape4_5" filter="url(#filter20_f_1511_8141)">
                                            <path
                                                d="M80.4779 673.219C-57.4586 540.322 70.8008 478.474 215.005 328.802C359.208 179.13 508.872 111.873 646.809 244.769C690.02 286.402 802.781 381.601 823.204 440.752C867.975 570.42 772.796 683.597 673.767 786.382C594.542 868.611 444.245 940.737 343.07 939.094C260.087 937.748 142.633 733.103 80.4779 673.219Z"
                                                fill="white"
                                            />
                                        </g>
                                        <g
                                            id="shape3_5"
                                            opacity={0.9}
                                            filter="url(#filter21_f_1511_8141)"
                                        >
                                            <ellipse
                                                cx={729.223}
                                                cy={-60.5171}
                                                rx={406.921}
                                                ry={542}
                                                fill="#BBDDE5"
                                            />
                                        </g>
                                        <g
                                            id="shape2_5"
                                            opacity={0.7}
                                            filter="url(#filter22_f_1511_8141)"
                                        >
                                            <path
                                                d="M448.502 355.972C448.502 440.849 425.8 473.754 340.923 473.754C256.046 473.754 89.3682 397.667 89.3682 312.79C89.3682 227.914 209.941 202.289 294.818 202.289C379.695 202.289 448.502 271.095 448.502 355.972Z"
                                                fill="#FDA599"
                                            />
                                        </g>
                                        <g
                                            id="shape1_5"
                                            opacity={0.9}
                                            filter="url(#filter23_f_1511_8141)"
                                        >
                                            <path
                                                d="M787.426 652.458C787.426 779.819 563.793 807.7 493.551 807.7C423.31 807.7 366.368 704.453 366.368 577.092C366.368 449.73 423.31 346.483 493.551 346.483C563.793 346.483 787.426 525.096 787.426 652.458Z"
                                                fill="#F4E28D"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g id="paragraph1_3">
                                <rect
                                    id="text3_2"
                                    x={284}
                                    y={254}
                                    width={290}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="text2_11"
                                    x={284}
                                    y={234}
                                    width={506}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="text1_11"
                                    x={284}
                                    y={214}
                                    width={486}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                            </g>
                            <rect
                                id="heading_5"
                                x={284}
                                y={174}
                                width={220}
                                height={8}
                                rx={4}
                                fill="#C3C5CB"
                            />
                            <rect
                                id="context_4"
                                x={284}
                                y={154}
                                width={64}
                                height={8}
                                rx={4}
                                fill="#84D0EF"
                            />
                        </g>
                        <g id="sidebar" clipPath="url(#clip11_1511_8141)">
                            <path
                                id="sidebarFill"
                                d="M40 146C40 141.582 43.5817 138 48 138H204C208.418 138 212 141.582 212 146V596C212 600.418 208.418 604 204 604H48C43.5817 604 40 600.418 40 596V146Z"
                                fill="#F7F7F8"
                            />
                            <g id="poweredBy">
                                <rect
                                    x={48.5}
                                    y={561.5}
                                    width={155}
                                    height={34}
                                    rx={3.5}
                                    stroke="#ECEDEF"
                                />
                                <text
                                    id="Powered by GitBook"
                                    fill="#343F47"
                                    xmlSpace="preserve"
                                    style={{
                                        whiteSpace: 'pre',
                                    }}
                                    className="font-sans"
                                    fontSize={11}
                                    fontWeight={500}
                                    letterSpacing="0em"
                                >
                                    <tspan x={85} y={582.5}>
                                        {'Powered by GitBook'}
                                    </tspan>
                                </text>
                                <path
                                    id="Logo"
                                    d="M67.16 578.924C67.9912 579.39 68.4068 579.623 68.8632 579.624C69.3196 579.624 69.7356 579.391 70.5676 578.926L75.8712 575.962C76.1106 575.829 76.2582 575.581 76.2582 575.312C76.2582 575.044 76.1106 574.795 75.8712 574.662L70.5657 571.697C69.7346 571.232 69.319 571 68.8631 571C68.4071 571 67.9917 571.233 67.161 571.698L62.6 574.251C62.5662 574.27 62.5493 574.28 62.5336 574.289C60.9756 575.176 60.013 576.794 60.0001 578.55C60 578.567 60 578.586 60 578.624C60 578.662 60 578.681 60.0001 578.699C60.013 580.452 60.9734 582.069 62.5286 582.957C62.5443 582.966 62.5612 582.975 62.595 582.994L65.4519 584.598C67.1167 585.532 67.9491 586 68.8631 586C69.7772 586 70.6099 585.534 72.2753 584.6L75.2913 582.91C76.1252 582.442 76.5421 582.209 76.7711 581.824C77 581.438 77 580.97 77 580.035V578.227C77 577.967 76.8554 577.728 76.6221 577.601C76.3963 577.479 76.1212 577.481 75.8972 577.606L69.713 581.062C69.298 581.294 69.0906 581.41 68.8629 581.41C68.6353 581.41 68.4277 581.295 68.0127 581.063L63.8271 578.727C63.6174 578.61 63.5126 578.551 63.4284 578.541C63.2364 578.517 63.0518 578.621 62.9787 578.796C62.9466 578.872 62.9473 578.99 62.9486 579.225C62.9495 579.398 62.95 579.484 62.9666 579.564C63.0039 579.742 63.1003 579.903 63.2411 580.023C63.304 580.077 63.3811 580.12 63.5352 580.206L68.0103 582.717C68.4265 582.951 68.6345 583.068 68.863 583.068C69.0915 583.068 69.2996 582.951 69.7159 582.718L75.201 579.644C75.3432 579.564 75.4143 579.524 75.4676 579.554C75.5209 579.584 75.5209 579.664 75.5209 579.824V580.643C75.5209 580.877 75.5209 580.994 75.4637 581.091C75.4065 581.187 75.3022 581.245 75.0937 581.362L70.5695 583.898C69.7367 584.365 69.3202 584.598 68.8631 584.598C68.406 584.598 67.9897 584.364 67.1573 583.896L62.9245 581.519C62.9111 581.512 62.9044 581.508 62.8981 581.504C62.0106 581 61.463 580.078 61.4578 579.078C61.4578 579.071 61.4578 579.064 61.4578 579.049V578.296C61.4578 577.744 61.76 577.234 62.251 576.957C62.6848 576.713 63.2199 576.713 63.6541 576.956L67.16 578.924Z"
                                    fill="#343F47"
                                />
                            </g>
                            <g id="additionalContent">
                                <rect
                                    id="link9"
                                    x={64}
                                    y={494}
                                    width={32}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="link8"
                                    x={64}
                                    y={474}
                                    width={62}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="link7"
                                    x={64}
                                    y={454}
                                    width={74}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="heading2_2"
                                    x={64}
                                    y={434}
                                    width={50}
                                    height={8}
                                    rx={4}
                                    fill="#C3C5CB"
                                />
                                <g id="subPages">
                                    <rect
                                        id="link4_2"
                                        x={82}
                                        y={394}
                                        width={56}
                                        height={8}
                                        rx={4}
                                        fill="#E6E7EA"
                                    />
                                    <rect
                                        id="link3_2"
                                        x={82}
                                        y={374}
                                        width={42}
                                        height={8}
                                        rx={4}
                                        fill="#E6E7EA"
                                    />
                                    <rect
                                        id="link2_2"
                                        x={82}
                                        y={354}
                                        width={48}
                                        height={8}
                                        rx={4}
                                        fill="#E6E7EA"
                                    />
                                    <rect
                                        id="link1_2"
                                        x={82}
                                        y={334}
                                        width={52}
                                        height={8}
                                        rx={4}
                                        fill="#E6E7EA"
                                    />
                                    <rect
                                        id="border_4"
                                        x={64}
                                        y={334}
                                        width={2}
                                        height={68}
                                        fill="#EAEBEE"
                                    />
                                </g>
                                <rect
                                    id="link6"
                                    x={64}
                                    y={314}
                                    width={50}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="link5"
                                    x={64}
                                    y={294}
                                    width={46}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="link4_3"
                                    x={64}
                                    y={274}
                                    width={54}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="link3_3"
                                    x={64}
                                    y={254}
                                    width={70}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="heading1_2"
                                    x={64}
                                    y={234}
                                    width={64}
                                    height={8}
                                    rx={4}
                                    fill="#C3C5CB"
                                />
                                <rect
                                    id="link2_3"
                                    x={64}
                                    y={194}
                                    width={46}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="link1_3"
                                    x={64}
                                    y={174}
                                    width={70}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                            </g>
                            <g id="currentPage">
                                <rect
                                    x={50}
                                    y={148}
                                    width={130}
                                    height={20}
                                    rx={3}
                                    fill="#E6F6FC"
                                />
                                <rect
                                    id="Link"
                                    x={64}
                                    y={154}
                                    width={68}
                                    height={8}
                                    rx={4}
                                    fill="#84D0EF"
                                />
                            </g>
                        </g>
                        <g id="sections">
                            <rect id="divider" y={121} width={1079} height={1} fill="#E6E7EA" />
                            <g id="links_2">
                                <rect
                                    id="link4_4"
                                    x={270}
                                    y={101}
                                    width={50}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="link3_4"
                                    x={212}
                                    y={101}
                                    width={42}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="link2_4"
                                    x={136}
                                    y={101}
                                    width={60}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <g id="link1_4">
                                    <rect
                                        id="Border"
                                        x={64}
                                        y={120}
                                        width={56}
                                        height={2}
                                        fill="#84D0EF"
                                    />
                                    <rect
                                        id="Link_2"
                                        x={64}
                                        y={101}
                                        width={56}
                                        height={8}
                                        rx={4}
                                        fill="#84D0EF"
                                    />
                                </g>
                            </g>
                        </g>
                        <g id="headerPaid">
                            <rect
                                width={1079}
                                height={51}
                                transform="translate(0 38)"
                                fill="#7DCDEE"
                            />
                            <g id="links_3">
                                <rect
                                    id="link3_5"
                                    x={961}
                                    y={59}
                                    width={54}
                                    height={8}
                                    rx={4}
                                    fill="#A4E0F9"
                                />
                                <rect
                                    id="link2_5"
                                    x={871}
                                    y={59}
                                    width={74}
                                    height={8}
                                    rx={4}
                                    fill="#A4E0F9"
                                />
                                <rect
                                    id="link1_5"
                                    x={795}
                                    y={59}
                                    width={60}
                                    height={8}
                                    rx={4}
                                    fill="#A4E0F9"
                                />
                            </g>
                            <g id="input">
                                <rect
                                    x={284}
                                    y={50}
                                    width={360}
                                    height={26}
                                    rx={4}
                                    fill="#A4E0F9"
                                />
                                <rect
                                    id="placeholder"
                                    x={316}
                                    y={59}
                                    width={64}
                                    height={8}
                                    rx={4}
                                    fill="#CBEFFD"
                                />
                                <g id="icon_2">
                                    <g id="search">
                                        <path
                                            id="handle"
                                            d="M302.5 64.5L305.5 67.5"
                                            stroke="#579EBA"
                                            strokeWidth={1.5}
                                        />
                                        <circle
                                            id="lens"
                                            cx={300}
                                            cy={62}
                                            r={4}
                                            stroke="#579EBA"
                                            strokeWidth={1.5}
                                        />
                                    </g>
                                    <g id="sparkles">
                                        <path
                                            id="sparkle3"
                                            d="M293.122 66.082C293.081 65.9726 292.919 65.9727 292.878 66.0821C292.643 66.7173 292.498 67.1084 292.261 67.4446C292.051 67.7421 291.789 68.0039 291.487 68.2189C291.146 68.4618 290.743 68.6198 290.087 68.8765C289.971 68.922 289.971 69.078 290.087 69.1235C290.743 69.3802 291.146 69.5382 291.487 69.7811C291.789 69.9961 292.051 70.2578 292.261 70.5554C292.498 70.8916 292.643 71.2827 292.878 71.9179C292.919 72.0273 293.081 72.0274 293.122 71.918C293.357 71.2827 293.502 70.8916 293.739 70.5554C293.949 70.2578 294.211 69.9961 294.513 69.7811C294.854 69.5382 295.257 69.3802 295.913 69.1235C296.029 69.078 296.029 68.9219 295.913 68.8765C295.257 68.6198 294.854 68.4618 294.513 68.2189C294.211 68.0039 293.949 67.7421 293.739 67.4446C293.502 67.1084 293.357 66.7173 293.122 66.082Z"
                                            fill="#4197BA"
                                        />
                                        <path
                                            id="sparkle2"
                                            d="M310.081 66.0547C310.054 65.9818 309.946 65.9818 309.919 66.0547C309.762 66.4782 309.665 66.7389 309.507 66.9631C309.367 67.1614 309.193 67.3359 308.992 67.4793C308.764 67.6412 308.495 67.7465 308.058 67.9177C307.981 67.948 307.981 68.052 308.058 68.0823C308.495 68.2534 308.764 68.3588 308.992 68.5207C309.193 68.6641 309.367 68.8386 309.507 69.0369C309.665 69.2611 309.762 69.5218 309.919 69.9453C309.946 70.0182 310.054 70.0182 310.081 69.9453C310.238 69.5218 310.335 69.2611 310.493 69.0369C310.633 68.8386 310.807 68.6641 311.008 68.5207C311.236 68.3588 311.505 68.2534 311.942 68.0823C312.019 68.052 312.019 67.948 311.942 67.9177C311.505 67.7465 311.236 67.6412 311.008 67.4793C310.807 67.3359 310.633 67.1614 310.493 66.9631C310.335 66.7389 310.238 66.4782 310.081 66.0547Z"
                                            fill="#4197BA"
                                        />
                                        <path
                                            id="sparkle1"
                                            d="M308.163 53.1094C308.109 52.9635 307.891 52.9636 307.837 53.1094C307.524 53.9564 307.331 54.4779 307.014 54.9261C306.734 55.3229 306.386 55.6719 305.983 55.9585C305.529 56.2824 304.99 56.4931 304.116 56.8354C303.961 56.896 303.961 57.104 304.116 57.1646C304.99 57.5069 305.529 57.7176 305.983 58.0415C306.386 58.3281 306.734 58.6771 307.014 59.0739C307.331 59.5221 307.524 60.0436 307.837 60.8906C307.891 61.0365 308.109 61.0365 308.163 60.8906C308.476 60.0436 308.669 59.5221 308.986 59.0739C309.266 58.6771 309.614 58.3281 310.017 58.0415C310.471 57.7176 311.01 57.5069 311.884 57.1646C312.039 57.104 312.039 56.8959 311.884 56.8353C311.01 56.4931 310.471 56.2824 310.017 55.9585C309.614 55.6719 309.266 55.3229 308.986 54.9261C308.669 54.4779 308.476 53.9564 308.163 53.1094Z"
                                            fill="#4197BA"
                                        />
                                    </g>
                                </g>
                            </g>
                            <g id="logo">
                                <path
                                    id="logomark"
                                    d="M73.2533 54.1169C73.1947 54.0592 73.1654 54.0304 73.1279 54.0152C73.0904 54 73.0486 54 72.965 54H64.814C64.4026 54 64.1968 54 64.1448 54.12C64.0928 54.2401 64.2371 54.3819 64.5256 54.6657L72.323 62.3343C72.6115 62.6181 72.7558 62.7599 72.7038 62.88C72.6518 63 72.4461 63 72.0346 63H64.6796C64.2682 63 64.0625 63 64.0105 63.12C63.9585 63.2401 64.1027 63.3819 64.3912 63.6657L72.7467 71.8831C72.8053 71.9408 72.8346 71.9696 72.8721 71.9848C72.9096 72 72.9514 72 73.035 72H81.186C81.5974 72 81.8032 72 81.8552 71.88C81.9072 71.7599 81.7629 71.6181 81.4744 71.3343L73.677 63.6657C73.3885 63.3819 73.2442 63.2401 73.2962 63.12C73.3482 63 73.5539 63 73.9654 63H81.3204C81.7318 63 81.9375 63 81.9895 62.88C82.0415 62.7599 81.8973 62.6181 81.6088 62.3343L73.2533 54.1169Z"
                                    fill="#3A617E"
                                />
                                <g id="wordmark">
                                    <g id="brand">
                                        <text
                                            id="title"
                                            fill="#343F47"
                                            xmlSpace="preserve"
                                            style={{
                                                whiteSpace: 'pre',
                                            }}
                                            className="font-sans"
                                            fontSize={14}
                                            fontWeight={600}
                                            letterSpacing="0em"
                                        >
                                            <tspan x={94} y={67.5909}>
                                                {'Org Docs'}
                                            </tspan>
                                        </text>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <g id="headerBasic">
                            <rect
                                width={1079}
                                height={51}
                                transform="translate(0 38)"
                                fill="white"
                            />
                            <rect id="divider_2" y={88} width={1079} height={1} fill="#E6E7EA" />
                            <g id="links_4">
                                <rect
                                    id="link3_6"
                                    x={961}
                                    y={59}
                                    width={54}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="link2_6"
                                    x={871}
                                    y={59}
                                    width={74}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <rect
                                    id="link1_6"
                                    x={795}
                                    y={59}
                                    width={60}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                            </g>
                            <g id="input_2">
                                <rect
                                    x={284}
                                    y={50}
                                    width={360}
                                    height={26}
                                    rx={4}
                                    stroke="#E6E7EA"
                                />
                                <rect
                                    id="placeholder_2"
                                    x={316}
                                    y={59}
                                    width={64}
                                    height={8}
                                    rx={4}
                                    fill="#E6E7EA"
                                />
                                <g id="icon_3">
                                    <path
                                        id="handle_2"
                                        d="M302.5 64.5L305.5 67.5"
                                        stroke="#C3C5CB"
                                        strokeWidth={1.5}
                                    />
                                    <circle
                                        id="lens_2"
                                        cx={300}
                                        cy={62}
                                        r={4}
                                        stroke="#C3C5CB"
                                        strokeWidth={1.5}
                                    />
                                </g>
                            </g>
                            <g id="brand">
                                <text
                                    id="title"
                                    fill="#343F47"
                                    xmlSpace="preserve"
                                    style={{
                                        whiteSpace: 'pre',
                                    }}
                                    className="font-sans"
                                    fontSize={14}
                                    fontWeight={600}
                                    letterSpacing="0em"
                                >
                                    <tspan x={94} y={67.5909}>
                                        {'Org Docs'}
                                    </tspan>
                                </text>
                                <text
                                    id="emoji"
                                    fill="#181C1F"
                                    xmlSpace="preserve"
                                    style={{
                                        whiteSpace: 'pre',
                                    }}
                                    className="font-sans"
                                    fontSize={18}
                                    letterSpacing="0em"
                                >
                                    <tspan x={64} y={70.74}>
                                        {'\uD83D\uDE80'}
                                    </tspan>
                                </text>
                            </g>
                        </g>
                        <g id="login">
                            <g id="content" />
                        </g>
                        <g id="browser">
                            <path
                                d="M0 4C0 1.79086 1.79086 0 4 0H1075C1077.21 0 1079 1.79086 1079 4V38H0V4Z"
                                fill="#EEEFF1"
                            />
                            <rect
                                id="input_3"
                                x={380}
                                y={8}
                                width={320}
                                height={22}
                                rx={4}
                                fill="#E0E2E6"
                            />
                            <text
                                id="url"
                                fill="#8D8D8D"
                                xmlSpace="preserve"
                                style={{
                                    whiteSpace: 'pre',
                                }}
                                className="font-sans"
                                fontSize={12}
                                letterSpacing="0em"
                            >
                                <tspan x={501.387} y={22.8636}>
                                    {'docs.org.com'}
                                </tspan>
                            </text>
                            <g id="actions">
                                <circle id="green" cx={45} cy={19} r={4} fill="#28C840" />
                                <circle id="amber" cx={32} cy={19} r={4} fill="#FEBC2E" />
                                <circle id="red" cx={19} cy={19} r={4} fill="#F2544C" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <defs>
            <filter
                id="filter0_f_1511_8141"
                x={-1566.56}
                y={-2572.19}
                width={2882.85}
                height={4426.38}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={95.9473} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter1_f_1511_8141"
                x={-1371.43}
                y={-2537.58}
                width={2481.13}
                height={2910.73}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={78.6454} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter2_f_1511_8141"
                x={-1129.94}
                y={-717.691}
                width={2411.63}
                height={2357.27}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={78.6454} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter3_f_1511_8141"
                x={-1531.96}
                y={-537.682}
                width={2411.63}
                height={2357.27}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={78.6454} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter4_f_1511_8141"
                x={558.416}
                y={311.79}
                width={478.694}
                height={481.688}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={7.92341} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter5_f_1511_8141"
                x={611.944}
                y={209.879}
                width={416.178}
                height={485.162}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={23.7702} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter6_f_1511_8141"
                x={472.337}
                y={203.582}
                width={446.662}
                height={473.922}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={19.0162} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter7_f_1511_8141"
                x={504.757}
                y={335.43}
                width={318.126}
                height={306.255}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={23.7702} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter8_f_1511_8141"
                x={382.416}
                y={311.79}
                width={478.694}
                height={481.688}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={7.92341} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter9_f_1511_8141"
                x={435.944}
                y={209.879}
                width={416.178}
                height={485.162}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={23.7702} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter10_f_1511_8141"
                x={316.337}
                y={233.582}
                width={446.662}
                height={473.922}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={19.0162} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter11_f_1511_8141"
                x={420.163}
                y={310.186}
                width={345.421}
                height={332.097}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={23.7702} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter12_f_1511_8141"
                x={206.416}
                y={311.79}
                width={478.694}
                height={481.688}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={7.92341} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter13_f_1511_8141"
                x={259.944}
                y={209.879}
                width={416.178}
                height={485.162}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={23.7702} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter14_f_1511_8141"
                x={61.1146}
                y={511.494}
                width={378.537}
                height={330.681}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={19.0162} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter15_f_1511_8141"
                x={229.115}
                y={506.494}
                width={378.537}
                height={330.681}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={19.0162} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter16_f_1511_8141"
                x={300.288}
                y={-187.18}
                width={1019.93}
                height={1188.99}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={58.2538} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter17_f_1511_8141"
                x={52.5203}
                y={62.5717}
                width={1173.14}
                height={1180.47}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={19.4179} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter18_f_1511_8141"
                x={-109.422}
                y={-129.094}
                width={1094.64}
                height={1161.44}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={46.6031} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter19_f_1511_8141"
                x={83.5912}
                y={78.0906}
                width={1061.6}
                height={1002.32}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={58.2538} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter20_f_1511_8141"
                x={-88.4747}
                y={63.5659}
                width={1032.98}
                height={985.48}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={54.9618} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter21_f_1511_8141"
                x={72.3018}
                y={-852.517}
                width={1313.84}
                height={1584}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={125} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter22_f_1511_8141"
                x={-160.632}
                y={-47.7115}
                width={859.134}
                height={771.465}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={125} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter23_f_1511_8141"
                x={116.368}
                y={96.4829}
                width={921.058}
                height={961.217}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation={125} result="effect1_foregroundBlur_1511_8141" />
            </filter>
            <filter
                id="filter24_d_1511_8141"
                x={-124.5}
                y={22}
                width={1211.5}
                height={573}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx={-8} />
                <feGaussianBlur stdDeviation={8} />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_1511_8141"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_1511_8141"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_1511_8141"
                x1={1035.03}
                y1={-1096.03}
                x2={-526.516}
                y2={-122.969}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FFF2E3" />
                <stop offset={0.14059} stopColor="#FFBE82" />
                <stop offset={0.645} stopColor="#FFBE82" />
                <stop offset={1} stopColor="#FFDCBC" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_1511_8141"
                x1={1533.33}
                y1={1001.8}
                x2={586.97}
                y2={-382.235}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.192317} stopColor="#F7CADC" />
                <stop offset={0.38} stopColor="#DAD4FF" />
                <stop offset={0.525} stopColor="#F7CADC" />
                <stop offset={1} stopColor="white" stopOpacity={0} />
            </linearGradient>
            <linearGradient
                id="paint2_linear_1511_8141"
                x1={1131.31}
                y1={1181.81}
                x2={184.953}
                y2={-202.226}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.192317} stopColor="#F7CADC" />
                <stop offset={0.38} stopColor="#DAD4FF" />
                <stop offset={0.525} stopColor="#F7CADC" />
                <stop offset={1} stopColor="white" stopOpacity={0} />
            </linearGradient>
            <linearGradient
                id="paint3_linear_1511_8141"
                x1={980}
                y1={289.5}
                x2={-20}
                y2={289.5}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="white" stopOpacity={0} />
                <stop offset={1} stopColor="white" stopOpacity={0.4} />
            </linearGradient>
            <radialGradient
                id="paint4_radial_1511_8141"
                cx={0}
                cy={0}
                r={1}
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(977.568 463.091) rotate(65.1799) scale(15.3241 27.4703)"
            >
                <stop stopColor="#3F89A1" />
                <stop offset={0.339725} stopColor="#F4E28D" />
                <stop offset={0.505624} stopColor="#BBDDE5" />
                <stop offset={0.848958} stopColor="#FDA599" />
            </radialGradient>
            <radialGradient
                id="paint5_radial_1511_8141"
                cx={0}
                cy={0}
                r={1}
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(1023.22 443.608) rotate(167.968) scale(73.8448 48.5358)"
            >
                <stop stopColor="#3F89A1" />
                <stop offset={0.19} stopColor="#F4E28D" />
                <stop offset={0.614011} stopColor="#BBDDE5" />
                <stop offset={1} stopColor="#FDA599" />
            </radialGradient>
            <radialGradient
                id="paint6_radial_1511_8141"
                cx={0}
                cy={0}
                r={1}
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(971.974 452.393) rotate(63.9544) scale(27.389 50.8373)"
            >
                <stop stopColor="#3F89A1" />
                <stop offset={0.339725} stopColor="#F4E28D" />
                <stop offset={0.505624} stopColor="#BBDDE5" />
                <stop offset={0.848958} stopColor="#FDA599" />
            </radialGradient>
            <radialGradient
                id="paint7_radial_1511_8141"
                cx={0}
                cy={0}
                r={1}
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(987.704 441.169) rotate(172.137) scale(57.2426 36.499)"
            >
                <stop stopColor="#3F89A1" />
                <stop offset={0.339725} stopColor="#F4E28D" />
                <stop offset={0.505624} stopColor="#BBDDE5" />
                <stop offset={0.848958} stopColor="#FDA599" />
            </radialGradient>
            <radialGradient
                id="paint8_radial_1511_8141"
                cx={0}
                cy={0}
                r={1}
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(966.38 441.694) rotate(63.4784) scale(39.4588 74.1778)"
            >
                <stop stopColor="#3F89A1" />
                <stop offset={0.339725} stopColor="#F4E28D" />
                <stop offset={0.505624} stopColor="#BBDDE5" />
                <stop offset={0.848958} stopColor="#FDA599" />
            </radialGradient>
            <linearGradient
                id="paint9_linear_1511_8141"
                x1={946.564}
                y1={656.03}
                x2={651.347}
                y2={371.599}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.045} stopColor="#F4E28D" />
                <stop offset={0.645} stopColor="#F4E28D" />
                <stop offset={1} stopColor="#5B6D72" />
            </linearGradient>
            <linearGradient
                id="paint10_linear_1511_8141"
                x1={770.564}
                y1={656.03}
                x2={475.347}
                y2={371.599}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.045} stopColor="#F4E28D" />
                <stop offset={0.645} stopColor="#F4E28D" />
                <stop offset={1} stopColor="#5B6D72" />
            </linearGradient>
            <linearGradient
                id="paint11_linear_1511_8141"
                x1={690.865}
                y1={551.706}
                x2={589.621}
                y2={459.3}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#D2F6FF" />
                <stop offset={0.239583} stopColor="#BBDDE5" />
                <stop offset={0.734375} stopColor="#BBDDE5" />
                <stop offset={1} stopColor="#BBDDE5" />
            </linearGradient>
            <linearGradient
                id="paint12_linear_1511_8141"
                x1={1003.76}
                y1={906.203}
                x2={280.266}
                y2={209.146}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.045} stopColor="#F4E28D" />
                <stop offset={0.645} stopColor="#F4E28D" />
                <stop offset={1} stopColor="#D2E9EE" />
            </linearGradient>
            <linearGradient
                id="paint13_linear_1511_8141"
                x1={808.438}
                y1={650.535}
                x2={560.318}
                y2={424.075}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#D2F6FF" />
                <stop offset={0.239583} stopColor="#BBDDE5" />
                <stop offset={0.734375} stopColor="#BBDDE5" />
                <stop offset={1} stopColor="#BBDDE5" />
            </linearGradient>
            <clipPath id="clip0_1511_8141">
                <rect width={1480} height={980} fill="white" transform="translate(-201 -201)" />
            </clipPath>
            <clipPath id="clip1_1511_8141">
                <rect width={1079} height={579} rx={8} fill="white" />
            </clipPath>
            <clipPath id="clip2_1511_8141">
                <rect width={16} height={16} fill="white" transform="translate(947 252)" />
            </clipPath>
            <clipPath id="clip3_1511_8141">
                <rect width={16} height={16} fill="white" transform="translate(927 252)" />
            </clipPath>
            <clipPath id="clip4_1511_8141">
                <rect width={16} height={16} fill="white" transform="translate(907 252)" />
            </clipPath>
            <clipPath id="clip5_1511_8141">
                <rect width={52} height={36} fill="white" transform="translate(514 298)" />
            </clipPath>
            <clipPath id="clip6_1511_8141">
                <rect x={636} y={525} width={160} height={91} rx={6} fill="white" />
            </clipPath>
            <clipPath id="clip7_1511_8141">
                <rect x={460} y={525} width={160} height={91} rx={6} fill="white" />
            </clipPath>
            <clipPath id="clip8_1511_8141">
                <rect x={284} y={525} width={160} height={91} rx={6} fill="white" />
            </clipPath>
            <clipPath id="clip9_1511_8141">
                <rect width={814} height={164} fill="white" transform="translate(217 89)" />
            </clipPath>
            <clipPath id="clip10_1511_8141">
                <rect x={284} y={294} width={512} height={140} rx={6} fill="white" />
            </clipPath>
            <clipPath id="clip11_1511_8141">
                <rect width={172} height={466} fill="white" transform="translate(40 138)" />
            </clipPath>
            <clipPath id="clip12_1511_8141">
                <rect width={29} height={9.996} fill="white" transform="translate(90 58.002)" />
            </clipPath>
            <clipPath id="clip13_1511_8141">
                <rect width={23} height={8} fill="white" transform="translate(127 59)" />
            </clipPath>
        </defs>
    </svg>
);
export default SiteTemplateSVG;
